import Vue from 'vue'
import IdleVue from 'idle-vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import TransactionModal from './components/transactionmodal.vue'
import InvoiceofTransaction from './components/InvoiceofTransaction'
import PeriodModal from './components/Periodmodal'
import PeriodofTransaction from './components/PeriodofTransaction'
import VueSimpleAlert from 'vue-simple-alert'
import VueToastify from 'vue-toastify'
import OtpInput from '@bachdgvn/vue-otp-input'
import VueSession from 'vue-session'

Vue.use(VueSession)
Vue.use(VueSimpleAlert)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.use(VueToastify, {
  position: 'bottom-right',
  hideProgressbar: true
})

VueCookies.config('7d')
Vue.component('Transactionmodal', TransactionModal)
Vue.component('InvoiceofTransaction', InvoiceofTransaction)
Vue.component('Periodmodal', PeriodModal)
Vue.component('PeriodofTransaction', PeriodofTransaction)
Vue.component('v-otp-input', OtpInput)
Vue.config.productionTip = false

const eventsHub = new Vue()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 30000000, // 50 minutes,
  // idleTime: 300000, // 5 minutes,
  startAtIdle: false
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
